export enum BijbModule {
  Carpool,
  Chat,
  Programma,
  Rsvp,
  Cadeaulijst,
  Galerij,
  Ceremoniemeesterpagina,
  Informatie
}
